<template>
    <div class="story-3" :class="{'slider-enabled' : sliderClass }">
        <div class="st-3-content">
            <transition :key="storyIndex" enter-active-class="animated fadeIn delay-1s"
                        leave-active-class="animated fadeOut" mode="out-in">
                <div class="st-3-content-1" v-if="storyIndex >= 0 && storyIndex <= 2">
                    <div class="st-3-header">
                        <transition enter-active-class="animated fadeIn"
                                    leave-active-class="animated fadeOut" mode="out-in">
                            <div :key="storyIndex" v-html="storySequence[storyIndex].text">
                                {{ storySequence[storyIndex].text }}
                            </div>
                        </transition>
                    </div>
                    <div class="st-image-container">
                        <transition enter-active-class="animated fadeIn delay-1s" leave-class="animated fadeOut"
                                    mode="out-in">
                            <div v-if="storyIndex === 0" class="st-i-c-1">
                                <img src="@/assets/img/story_3_images/180.png">
                            </div>
                        </transition>
                        <div v-if="storyIndex === 1" class="mobile-indicators">
                            <p>İstanbul / 2,84 milyar ton Su</p>
                            <p>İzmir / 1,22 milyar ton Su</p>
                            <p>Ankara / 1,84 milyar ton Su</p>
                            <p>Adana / 0,98 milyar ton Su</p>
                        </div>
                        <transition enter-active-class="animated fadeIn delay-1s" leave-class="animated fadeOut"
                                    mode="out-in">
                            <div v-if="storyIndex === 1" class="st-i-c-2">
                                <svg class="chart-1">
                                    <line x1="15" y1="15" x2="15" y2="340"
                                          style="stroke:rgba(255,255,255, 0.3);stroke-width:30"
                                          stroke-linecap="round"/>
                                    <line class="path"
                                          :class="{ 'dash-it' : storyIndex >= -1 }" x1="15" y1="15" x2="15" y2="340"
                                          style="stroke:#00bfed; stroke-width:15" stroke-linecap="round"/>
                                </svg>
                                <ChartIndicator :computed-props="chartIndicators.istanbul"/>
                                <svg class="chart-2">
                                    <line x1="15" y1="15" x2="15" y2="340"
                                          style="stroke:rgba(255,255,255, 0.3);stroke-width:30"
                                          stroke-linecap="round"/>
                                    <line class="path"
                                          :class="{ 'dash-it' : storyIndex >= -1 }" x1="15" y1="15" x2="15" y2="340"
                                          style="stroke:#00bfed; stroke-width:15" stroke-linecap="round"/>
                                </svg>
                                <ChartIndicator :computed-props="chartIndicators.izmir"/>
                                <svg class="chart-3">

                                    <line x1="15" y1="15" x2="15" y2="340"
                                          style="stroke:rgba(255,255,255, 0.3);stroke-width:30"
                                          stroke-linecap="round"/>
                                    <line class="path"
                                          :class="{ 'dash-it' : storyIndex >= -1 }" x1="15" y1="15" x2="15" y2="340"
                                          style="stroke:#00bfed; stroke-width:15" stroke-linecap="round"/>
                                </svg>
                                <ChartIndicator :computed-props="chartIndicators.ankara"/>
                                <svg class="chart-4">
                                    <line x1="15" y1="15" x2="15" y2="340"
                                          style="stroke:rgba(255,255,255, 0.3);stroke-width:30"
                                          stroke-linecap="round"/>
                                    <line class="path"
                                          :class="{ 'dash-it' : storyIndex >= -1 }" x1="15" y1="15" x2="15" y2="340"
                                          style="stroke:#00bfed; stroke-width:15" stroke-linecap="round"/>
                                </svg>
                                <ChartIndicator :computed-props="chartIndicators.adana"/>
                                <div class="turkey-map-container">
                                    <img class="turkey_map" src="@/assets/img/story_3_images/turkey_map.png">
                                </div>
                            </div>
                        </transition>
                        <transition enter-active-class="animated fadeIn delay-1s" leave-class="animated fadeOut"
                                    mode="out-in">
                            <div v-if="storyIndex === 2" class="st-i-c-3">
                                <svg height="0" width="0">
                                    <clipPath id="turkey-map-outline">
                                        <path id="turkey-map-path" stroke="black" stroke-width="1px"
                                              d="M325.4 13c.776 0 8.41 3.039 9.155 3.814-6.858-2.295-1.52 9.146 0 11.44 6.113 7.628 18.31 6.108 25.198 1.52-.775 1.52-1.52 3.039-1.52 4.588.775-6.108 6.113-.774 6.858 2.294 1.52 4.588 1.52 7.627 5.338 11.441 3.042 3.039 6.113 5.333 9.154 2.294 4.593-3.813 6.859-5.333 12.972-1.52 5.338 3.04 3.817 6.853 9.93 7.628 3.817.775 9.155 5.333 12.972 3.813 1.52-.774 3.041-3.813 4.592-3.813 1.52 0 3.817 2.294 4.592 3.039 1.521 1.52 1.521 2.294 3.042 3.813 2.296.775 6.113.775 8.41 1.52 4.592.775 7.633 1.52 12.226.775 4.592-1.52 8.41-2.295 13.747-4.589 2.296-.774 4.592-2.294 6.859-2.294 2.296 0 4.592.775 6.113.775 2.296-.775 3.817-3.04 6.113-2.294 2.296 0 3.817 2.294 5.338 3.813 4.592 2.294 10.675 1.52 16.043 3.04 5.338.774 10.675-2.295 15.268-4.589 4.592-1.52 7.634-6.108 11.45-8.402 5.338-3.039 10.676-5.333 15.268-8.402 3.042-2.294 5.338-7.627 9.155-7.627 1.52 0 3.817 1.52 5.338 1.52 3.041.774 2.296 0 5.338-.775 6.858-3.04 11.45.774 18.309 0 3.041-.775 3.041-2.295 5.337-3.814 3.042-3.04 4.593-3.04 9.155-2.294-.775 5.333 1.52 3.039 4.592 5.333.776.775 8.41 6.852 8.41 6.852-.569.569-1.121 1.12-1.681 1.375l-.085.033.158-.012c2.06-.068 4.056 2.418 5.425 2.418 2.296.775 3.041-.775 5.338.775 2.296 1.52 2.296 5.333 4.592 7.627 2.296 2.294 4.592 3.814 6.113 6.853 1.52 3.039 1.52 6.107.775 9.921-.775 2.294-3.041 3.814-3.817 5.333-1.52 5.333 5.338 10.666 5.338 16.03 0 .774-3.042-.775-1.52 1.519.775 1.52 3.04 2.294 4.591 2.294 3.817.775 7.634.775 12.227.775 6.859-.775 9.93 0 15.268 4.588 3.041 3.039 10.675 6.108 10.675 11.44-3.042-2.293-6.859-7.627-10.675-3.813-2.296 2.294-1.521 6.853-1.521 9.147v.552c-.01 2.68-.144 4.13-2.296 5.555-2.296 1.52-7.634-.774-9.93 1.52-2.297 3.813 2.296 7.627 3.817 9.921 2.296 3.814.775 7.628 3.041 10.666 1.521 2.294 3.042 2.294 3.817 5.333 0 1.52-.775 3.814 0 5.333 0 1.52 1.521 3.04 2.296 5.334 0 1.519-.775 3.813 0 5.333 1.521 3.039 4.593.774 6.113 3.039 1.521 2.294-2.296 7.627-3.041 9.921-.776 2.294-5.338 9.147-3.042 12.216.775 1.52 5.338 1.52 6.859 3.039 1.52.774 6.113 3.039 6.858 4.588 0 .775-.775 2.294-.775 3.814s.775 3.039 1.52 3.813c.776 3.04 2.297 4.588 4.593 6.853C685 218.07 685 220.365 685 225.698c-6.113-8.402-16.043 15.254-20.605 6.852-1.521-3.813 2.296-6.107 0-9.146-3.817-6.108-8.41 0-12.227 1.52-10.675 5.332-20.605-4.589-31.311-3.04-4.592.775-9.93 0-12.972 3.814-1.52 2.294-2.296 4.588-3.817 6.108-2.296 2.294-5.337 3.039-7.634 3.813 0-2.294-1.52-7.627-3.816-9.146-3.817-1.52-6.114 4.588-9.155 6.107-9.155 5.333-22.902 7.628-32.832 6.853-12.971-1.52-20.605 2.294-30.536 9.146-9.93 6.108-20.605 10.666-32.056 12.216-9.93 1.52-21.38 2.294-29.76-3.813-9.93-7.628-18.31-2.294-27.494 2.294-4.592 2.294-9.155 5.333-14.492 6.107-2.297 0-5.338-.774-7.634-.774-1.521 0-2.296.774-3.817.774-4.593 0-2.296-3.039-5.338-5.333-3.042-3.039-8.41-2.294-11.45-3.039.774 4.589-2.297 8.402-2.297 12.96 0 2.295 2.296 8.403.775 9.922 2.296-.775 3.817 1.52 2.296 3.039-.775 2.294-4.592 2.294-6.113 1.52-3.041 0-3.817-1.52-4.592 1.519-.775 2.294 1.52 5.333 0 7.627-.775.775-1.52 0-1.52.775 0 0-1.522 2.294-2.297 2.294h-2.296c-.775.775 0 2.294-.775 3.039-1.521 2.294 0 2.294-2.296 2.294-3.042 0-4.593-4.588-8.41-3.814 3.817-6.852-4.592-9.921-4.592-16.773 0-7.628 9.154-8.402 12.971-12.96 3.817-3.814 2.296-13.736-3.041-15.255-4.593-1.52-4.593 3.039-7.634 4.588-2.296 1.52-8.41 1.52-9.155 4.589 0-2.295-1.52 0-1.52 1.519.775 0 .775-.775.775 0s1.52-2.294 3.817-1.52l-.506.259c-1.344.691-2.622 1.43-3.311 2.78 1.52 0 2.296-2.294 3.041-2.294-1.52.775-1.52 3.04-3.041 3.814-1.521 1.52-3.042.775-5.338 1.52-3.817.774-6.113 1.519-9.93-.775-3.817-2.294-6.113-3.814-9.93-6.108h-1.521c0-.774 0-1.52-.776-2.294-1.52-.775-2.296-1.52-4.592-2.294-6.113-.775-12.226 5.333-16.788 9.146-3.042 3.04-6.859 6.108-9.155 9.922-1.52 2.294-2.296 6.853-4.592 7.627 1.52-4.588-2.296-4.588-4.592-3.039-1.521.775-5.338 4.588-5.338 6.108-1.521-3.814-3.817 0-6.113 0-.776 0-3.042-.775-3.817-.775-3.042 0-11.451-1.52-12.227 3.04-3.041-2.295-6.858 0-9.93.774-3.042.774-5.338 0-7.634-.775-6.113-2.294-9.93-6.852-13.747-12.215-3.817-5.334-6.859-9.147-12.971-12.216-6.114-3.04-12.227-6.108-18.31-9.922-6.113-3.813-10.675-3.039-17.564-3.813-5.338-.775-10.675-3.814-12.226 3.813-.775 2.294.775 4.589 0 6.108-.775 3.039-3.042 4.588-3.817 7.627 0 2.294.775 3.04 0 5.333 0 .75-3.567 4.338-3.805 5.249l-.013.081-.004-.186c-.154-2.944-3.875-5.128-6.854-4.399-3.041.775-3.817 3.814-6.858 1.52.775.774-4.593 1.52-4.593 1.52-2.296.774-3.817 3.038-6.113 3.038.776-2.294-2.296-.774-3.041.775-.733-.732-1.438-1.437-1.514-2.793l-.008-.238v.124c-.007.429-.108-.907-1.52-.907 3.042-.774-3.042-1.52-4.592-2.294-3.042-.775-6.859-3.039-9.155-4.588-3.041-2.294-3.041-3.814-3.041-6.853 0-3.039.775-5.333-3.817-3.813 0 0 2.296-3.814 2.296-4.589.081 0 .154.009.219.024l.053.017-.027-.049c-.988-1.648-5.583-5.325-5.583-5.325-.775 1.52-1.52 2.294-2.296 3.04-.775 1.519.775 3.813.775.774.775 1.52-.775 3.039-2.296 3.039.775-.775.775-1.52-.775-2.294-.776-.775-1.521-.775-2.296-1.52-1.521-.774-3.042-2.294-4.593-1.52-.775-1.519 0-3.813-.775-5.332-.775 1.52-1.52 0-2.296-.775-.775.775-.775 1.52-.775 2.294-1.521-1.52-2.297-2.294-2.297-4.588-.775 0-2.296.775-3.041 1.52 0 .774.775.774.775 1.519-.775 1.52-3.817 0-4.592.775.775-.775.775-1.52 0-1.52-3.042-.775 0 5.333 0 6.108-2.296-2.294-12.227 10.666-12.227 4.588.739 0 3.533-.703 4.467-1.413l.039-.034-.013-.013c-.338-.383-1.421-3.098-1.421-3.098-.775.774-1.521 1.52-3.042 0 1.521-1.52 4.592 0 6.113-1.52-1.52-.775-.775-2.294 0-1.52.776-3.038-5.338-.774-6.113-.774-2.296 0-6.113-1.52-7.634-.775-1.52.775-1.52 2.294-2.296 3.04-1.399.712-1.51.769-3.308.774h-.84c-2.44-.006-7.338-.138-8.078-3.039 1.52.775 5.337-.775 6.113-.775.775 0 2.296-1.52 3.041-1.52h12.64c1.891-.01 6.102-.124 2.598-1.519.776 0 .776 0 0-.774 2.296 0 2.296-1.52.776-2.294 0 0 .775-.775.775-1.52h.364c1.501.01 3.512.117 4.228 1.52-.775-3.814 6.859-3.04 6.113-5.333 0-1.52-8.41-1.52-8.41 0-3.04-3.04-9.93-.775-13.746-.775-2.297 0-4.593.775-6.859 0-1.52 0-3.817-3.04-5.338-1.52 0 0-.681 0-.766.639l-.01.134-.041-.194c-.788-3.429-2.295 1.702-4.55.97-3.042-.774 1.52-6.852 0-6.852 1.52 0 3.041 0 3.041-1.52 1.521 3.04 6.113 3.04 9.155 1.52-2.296.775-1.52-2.294 0-3.039.775 0 .775.775.775.775.775 0 2.296-3.814 1.521-3.814-1.52-2.294-2.296 1.52-3.817 1.52 1.52-1.52-.775-1.52-1.52-.775.775-.775 2.295-3.039.775-3.814-.776 3.04-2.297 1.52-2.297 0 0-.774 1.521-2.294 1.521-3.039 0-1.52-4.592 0-3.817 2.294-1.52-.774-3.817 0-5.338-.774.776-1.52 3.042-6.108 0-5.333 1.521-2.294 1.521-3.814 0-6.108-.775-.775-5.337-3.039-5.337-3.039 1.52-3.039 6.113-.775 7.634-3.039.775-.775 2.296-5.333 2.296-6.853 0-3.813-2.296-3.813-5.338-5.333-1.52-.774-1.52-1.52-3.042-2.294-1.52-.774-2.296.775-3.817 0-2.296-.774-2.296-3.039-3.041-5.333-.776-1.52-3.042-3.813-5.338-3.039-1.52.775-.775 3.04-3.042 3.814-2.296-.775-6.858-6.108-6.858-7.627 0 3.039-5.338 0-4.593-1.52 2.297 0 2.297-1.52 2.297-3.813.775 0 0 2.294.775 0 0 1.519 2.296 4.588 2.296 1.519 4.503 2.294 4.503 1.55 5.248 1.55h.001c1.521 0 2.296-2.295 1.521-3.814 2.296 3.039.775-5.333-2.296-1.52 1.52-2.294-3.042-16.774 6.113-8.402 1.52 1.52 3.042 3.814 3.042 5.333 0 1.52-1.521 3.04-1.521 3.04 0 1.476 0 5.854 2.11 6.78l.067.026-.009-.006c-.55-.504.177-4.537.903-4.537 2.297-1.519 2.297 1.52 3.817 2.295 3.817 1.52 9.93-.775 13.747-3.04-6.858-.774-7.633.775-12.226-5.333.775.775 1.52 1.52 2.296 1.52-.775-1.52-1.52-3.814-2.296-4.588 0-.775-2.296-.775-2.296-1.52 0-.774 0-3.039.775-3.813 2.296-1.52 9.155.774 5.338-3.814.747-.746 1.466-.774 2.21.609l.001.001-.002-.057c.086-.815 3.904-2.138 3.904-2.817.775-3.814-6.113-1.52-6.859-3.04-3.817-3.038.776-4.588.776-7.627 0-2.294-5.338-8.402-7.634-8.402 0-.464.279-.918.663-1.375l.124-.143.08.006c.654.079.654.809.654 1.512.775-4.588 19.084-12.215 5.337-12.96-4.592 0-25.943 6.853-25.198-.774 0-3.814 3.817-6.853 3.817-10.666.776-5.333 0-7.628 4.593-10.666 2.296-1.52 3.041-1.52 4.592-3.04.775-1.519 1.52-3.038 3.042-4.587 1.52-1.52 10.675-7.628 9.93-7.628 3.041-1.52 5.338 0 8.41 0 2.295 0 4.591-1.52 6.858-1.52.775 0 7.634-.774 6.113 2.295-.775 1.52-.775 1.52 1.52 3.039 1.522 1.52 4.593 1.52 6.114 2.294 3.817.775 9.154 0 11.45-2.294-3.041-1.52-8.409-6.108-3.041-6.853 2.296 0 8.41 1.52 7.634 3.814-.775 1.52-4.592.775-3.042 3.039.776 1.52 5.338.775 6.113 0h9.155c.775 0 5.338-.775 3.042.775 6.113-3.04 15.267 6.107 21.38 1.52 7.635-5.334-8.409-3.815-9.154-6.853-2.296-6.108 14.492-6.108 17.564-6.108 2.296 0 4.592-2.294 6.859-1.52 1.52 0 2.296 1.52 3.817 1.52l.517-.001c2.534-.009 10.996-.12 11.71-1.519 0-.774-7.635-2.294-9.155-2.294-2.297 0-5.338.775-7.634 0-1.521 0-4.593-3.039-6.113-2.294 3.041-1.52-7.634-6.853-7.634-9.146v-.775c1.52-.775 2.296-2.294 2.296-3.814h.775v-.774h-.775v-.775c0-.775.775-1.52 1.52-1.52l.776-1.519c8.41-3.814 17.564 3.04 25.943 4.588 5.338.775 8.41-.774 12.972-.774 5.337 0 9.93 3.039 15.267 4.588 6.859 2.294 19.86 4.588 23.678-3.814 1.52-3.039.775-3.813 2.296-5.333 3.041-3.039 9.93-4.588 14.492-6.852 9.155-5.333 16.789-11.441 26.719-14.48 9.93-3.039 20.605-9.146 30.535-8.402 5.338.775 10.676 1.52 16.789 2.294 6.113.775 11.45.775 17.564.775 3.817 0 7.634 1.52 11.45-.775.776-.775 3.818-5.333 3.818-5.333zM30.69 125.828c0 .732 0 .772-.653.775l-.079-.001c.231-.26.483-.516.732-.774zM60.744 0c.775 0 1.52.773 2.295.773 3.814 2.29 3.814 6.839 7.629 9.128-1.52-3.033 8.404-3.033 9.148-1.516 0-.773 7.63-1.517 6.11 4.578-.776 3.033-1.52 3.033 0 7.612 1.52 3.033 3.039 6.095 5.334 9.128 4.589 4.579 10.668 7.612 16.777 10.644 1.52.773 12.963 3.806 12.963 6.096l-1.52 1.516s-.775 0-.775.773.775.773.775 1.516c0 .773-.775 1.517-.775 2.29v.773c-.774 0-1.52.773-2.294 1.516v.773c-3.04.773-6.854 2.29-9.924 1.517-3.04-.773-3.04-5.322-6.109-6.096 1.52 1.517 1.52 3.806 0 3.806-.775 0-3.04-1.516-3.814-2.29-6.11-3.032-9.924-2.289-15.258 0-2.295.774-.775 1.517-4.59.774-1.52-.773-3.039-1.517-5.334-1.517-7.629-.773-7.629 3.806-10.668 8.386-6.854 9.127-19.072 9.127-26.701 15.223-3.814 3.033-6.854 5.322-9.924 8.385-.685 2.2-4.5 9.039-7.54 6.75.776.772 2.296-12.934 2.296-12.191 1.52-2.29 9.148-4.58 11.443-5.323 2.294-.773 6.854-.773 9.148-3.033 6.11-5.322-5.334-3.805-8.404-3.805-3.814.773-9.148 1.516-12.963 0-2.898-1.433-3.06-3.554-3.068-6.34L15 59.347c3.04.773 4.59-3.033 6.11-4.579 1.52-1.516 2.294-.773 3.04-2.29 1.52-1.516 4.589-9.127 1.52-9.9 2.294-3.806 3.039-6.84 7.628-9.128 2.295-.773 3.04.773 4.59-2.29.774-1.516 0-3.806 0-5.322-.776-5.322-2.295-6.839-6.11-10.644-4.589-4.58-.775-3.806 3.04-5.323 3.04-1.516 1.52-2.289 3.04-3.805 2.294-3.033 3.04-2.29 6.109-1.517 4.589 0 7.628-2.29 11.443-3.033h3.814c0-.773 0-1.516 1.52-1.516zM8.746 82.065c.732.812 0 5.594 2.254 4-1.493 4.813-22.48-.813-2.254-4zm59.458-9.929c-7.187-1.593 4-6.406 4-3.187 0 1.594-3.187 2.375-4 3.187z"/>
                                    </clipPath>
                                </svg>
                                <video id="crowded-video" src="@/assets/videos/crowd.mp4" autoplay muted loop/>
                                <div id="crowd-text">
                                    60 MİLYON İNSAN
                                </div>
                            </div>
                        </transition>
                    </div>
                    <div class="st-3-timeline" v-if="storyIndex >= 0 && storyIndex <= 2">
                        <p class="animated fadeIn">2004</p>
                        <LineWithDots :class="{ 'st-200' : storyIndex >= 1 }"/>
                        <p v-if="storyIndex >= 1" class="animated fadeIn delay-1s">2020</p>
                        <LineWithDots :class="{ 'st-200' : storyIndex >= 2 }"/>
                        <p v-if="storyIndex >= 2" class="animated fadeIn delay-1s">2030</p>
                    </div>
                </div>
            </transition>
            <transition :key="storyIndex" enter-active-class="animated fadeIn delay-1s"
                        leave-active-class="animated fadeOut" mode="in-out">
                <div class="st-3-content-2" v-if="storyIndex === 3">
                    <div class="st-2-left-container">
                        <img src="@/assets/img/story_3_images/cape_town_subs.png">
                    </div>
                    <div class="right-container">
                        <h3>BEKLEYEN TEHLİKE:</h3>
                        <h2>SIFIR GÜNÜ 25 LİTRE</h2>
                        <p>Güney Afrika’da yer alan Cape Town’da su kıtlığı olanca şiddetiyle devam ediyor.</p>
                        <p>2018 yılında bireysel kullanım için kişi başı yalnızca 25 litre su verilebilirdi!</p>
                        <p>Türkiye’de de benzer bir kriz yaşanabilir.</p>
                    </div>
                </div>
            </transition>
            <transition :key="storyIndex" enter-active-class="animated fadeIn delay-1s"
                        leave-active-class="animated fadeOut" mode="in-out">
                <div class="st-3-content-3" v-if="storyIndex === 4">
                    <Slider :slides="slides"/>
                    <div class="story-button-container" @click="nextSlide">
                        <div class="blue-button">
                            <img src="@/assets/img/icons/white-drop.svg"/>
                            <p>{{ slides[sliderIndex].button }}</p>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import ButtonBlueBackground from "../components/ButtonBlueBackground";
    import EventBus from "../main";
    import LineWithDots from "../components/LineWithDots";
    import Slider from "../components/Slider";
    import ChartIndicator from "../components/ChartIndicator";


    export default {
        name: "Story3",
        data() {
            return {
                storyIndex: 0,
                storyTotal: 4,
                storySequence: {
                    0: {
                        text: 'Son 15 Yılda Tüketim 4 kat arttı '
                    },
                    1: {
                        text: 'Türkiye’de nüfusun artması ve nüfusun şehirlerde birikmesi sonucu su seviyesinin\n' +
                            'şu an kritik olduğu şehirler. '
                    },
                    2: {
                        text: "2030 Yılında ülke nüfüsunun %65'i Su kıtlığı ile karşı karşıya kalacak"
                    }
                },
                chartIndicators: {
                    "istanbul": {
                        "container": `bottom: 299px; left: 121px; z-index: 2;`,
                        "line": "",
                        "textPos": "top: -15px; width: max-content; left: 45px;",
                        "text": "İstanbul / 2,84 milyar ton Su"
                    },
                    "izmir": {
                        "container": `bottom: 204px; left: 45px; z-index: 2;`,
                        "line": "transform: rotate(-180deg);",
                        "textPos": "top: -15px; width: max-content; left: -175px;",
                        "text": "İzmir / 1,22 milyar ton Su"
                    },
                    "ankara": {
                        "container": `left: 265px; bottom: 209px; z-index: 2; `,
                        "line": "",
                        "textPos": "top: -15px; width: max-content; left: 45px;",
                        "text": "Ankara / 1,84 milyar ton Su"
                    },
                    "adana": {
                        "container": `bottom: 76px; left: 330px; z-index: 2;`,
                        "line": `position: absolute; display: block; width: 70px; height: 1px; margin: 4px 0 4px 9.5px; background: white; transform-origin: -5px center; transform: rotate(90deg); `,
                        "textPos": `top: 75px; width: max-content; left: -75px;`,
                        "text": "Adana / 0,98 milyar ton Su"
                    }
                },
                storyInterval: null,
                sliderClass: false,
                slides: [
                    {
                        'header': '2015',
                        'image': 'story_3_images/group@2x.jpg',
                        'text': 'Cape Town su krizi 2015 yılında başladı. Belirli bölgelerde su kıtlığı baş gösterdi. 2018’in Nisan ayında “Day Zero (Sıfır Günü)” beklenmeye başladı. Bu şekilde, Cape Town Dünya’da suyu biten ilk büyük şehir olmaya aday  oldu.',
                        'button': '25 LİTRE İLE NE YAPILIR? '
                    },
                    {
                        'header': '25 Litre ile Ne Yapılır?',
                        'image': 'story_3_images/bitmap@3x.png',
                        'text': `<strong>TEMEL İHTİYAC</strong><br/>25 litre, Dünya Sağlık Örgütü'ne göre temel ihtiyaçların karşılanabilmesi için alt limittir.`,
                        'button': 'Ne yapabiliriz?'
                    }
                ],
                sliderIndex: 0,
                sliderDone: false,
                storyDone: false
            }
        },
        watch: {
            storyIndex(value) {
                if (value === 3) {
                    this.startThirdStory();
                    EventBus.$emit('story-background', 'hide-dune-video');
                } else if (value === 4) {
                    this.sliderClass = true;
                }
            },
            sliderIndex(value) {
                value === this.slides.length - 1 ? this.storyDone = true : this.storyDone = false;
            },
            storyDone(value) {
                value ? EventBus.$emit('story-done', {story: 3, value: true}) : EventBus.$emit('story-done', {
                    story: 3,
                    value: false
                });
            }
        },
        methods: {
            startStory() {
                EventBus.$emit('story-background', 'show-dune-video');
                this.$store.commit('changeStory', 3);
                this.storyInterval = setInterval(() => {
                    this.storyIndex < this.storyTotal - 1 ? this.storyIndex++ : clearInterval(this.storyInterval);
                }, 10000);
            },
            startThirdStory() {
                setTimeout(() => {
                    this.storyIndex++;
                }, 10000);
            },
            nextSlide() {
                if (this.sliderIndex === this.slides.length - 1) {
                    this.$router.push({name: 'Story4'});
                } else {
                    this.sliderIndex++;
                    EventBus.$emit('next-slide');
                }
            }
        },
        mounted() {
            EventBus.$emit('menu-status', false);
            this.$store.commit('navigationStatus', 'story');
            EventBus.$on('restart-story', () => {
                this.sliderDone = false;
                this.storyDone = false;
                this.storyIndex = 0;
                this.sliderIndex = 0;
                this.startStory();
            })
        },
        created() {
            setTimeout(this.startStory.bind(this), 2000);
        },
        beforeDestroy() {
            if (!(this.$route.name).includes('Story')) {
                EventBus.$emit('destroy-sequence');
            }
            EventBus.$emit('story-background', 'hide-dune-video');
            clearInterval(this.storyInterval);
        },
        components: {
            Slider,
            LineWithDots,
            ButtonBlueBackground,
            ChartIndicator
        }
    }
</script>

<style lang="scss">
    .story-3 {
        height: auto;
        width: 100% !important;
        margin: 45px auto auto auto !important;
        @media only screen and (max-device-width: 768px) {
            max-height: initial;
            height: 80% !important;
        }

        &.slider-enabled {
            width: 100vw;
            max-width: 100vw !important;
        }

        .st-3-content {
            height: auto;
            max-height: 800px;
            width: 100%;
            display: flex;
            flex-direction: column;
            min-height: 600px;
            position: relative;


            @media only screen and (max-device-width: 768px) {
                max-height: initial;
                height: 80%;
                .story-button-container {
                    right: initial !important;
                    left: 50%;
                    transform: translateX(-50%);

                    div.blue-button {
                        width: 670px;
                        min-height: 100px;

                        img {
                            height: 56px;
                            width: auto;
                        }

                        p {
                            font-size: 30px;
                        }
                    }
                }

                #slider-component {
                    .sc-header {
                        font-size: 53px;
                    }

                    .sc-text {
                        font-size: 36px;
                    }
                }
            }

            div[class*="st-3-content-"] {
                display: flex;
                flex-direction: column;

                div[class*="-header"] {
                    text-align: center;
                    font-size: 23px;
                    font-weight: bold;
                    font-stretch: normal;
                    font-style: normal;
                    margin: 0 auto 16px auto;
                    width: 700px;
                    @media only screen and (max-device-width: 768px) {
                        width: 100%;
                        font-size: 36px;
                        min-height: 80px;
                    }
                }

                @media only screen and (max-device-width: 768px) {
                    justify-content: space-between;
                    height: 100%;
                }
            }

            .st-3-content-1 {
                display: flex;
                height: 600px;

                .st-image-container {
                    margin: auto;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;

                    .mobile-indicators {
                        display: none;
                    }

                    .st-i-c-1 {
                        img {
                            width: 583px;
                            height: 301px;
                            margin: 0 auto;
                            display: block;
                            -webkit-animation: hover 10s infinite ease-in-out;
                            -o-animation: hover 10s infinite ease-in-out;
                            animation: hover 10s infinite ease-in-out;
                        }
                    }

                    .st-i-c-2 {
                        position: relative;
                        width: 660px;
                        height: 400px;
                        overflow: visible;

                        .mobile-indicators {
                            display: none;
                        }

                        & > * {
                            position: absolute;

                            &[class*="chart-"] {
                                width: 30px;
                            }
                        }

                        .chart-1 {
                            bottom: 140px;
                            left: 111px;
                            z-index: 1;
                            height: 170px;
                        }

                        .chart-2 {
                            bottom: 85px;
                            left: 35px;
                            z-index: 1;
                            height: 130px;
                        }

                        .chart-3 {
                            bottom: 110px;
                            left: 255px;
                            z-index: 1;
                            height: 110px;
                        }

                        .chart-4 {
                            bottom: 60px;
                            left: 320px;
                            z-index: 1;
                            height: 90px;
                        }

                        .turkey-map-container {
                            width: 100%;
                            bottom: 0;
                            top: initial;

                            img {
                                width: 100%;
                                height: 100%;
                                -o-object-fit: contain;
                                object-fit: contain;
                            }
                        }

                        @media only screen and (max-device-width: 768px) {
                            .ci-container {
                                display: none;
                            }
                        }
                    }

                    .st-i-c-3 {
                        position: relative;
                        width: 680px;
                        height: 400px;
                        overflow: hidden;

                        img {
                            width: 100%;
                            height: 311px;
                        }

                        video#crowded-video {
                            min-width: 100%;
                            -webkit-clip-path: url(#turkey-map-outline);
                            clip-path: url(#turkey-map-outline);
                            position: absolute;
                            top: initial;
                            transform: translateY(10%);
                            width: auto;
                            height: 100%;
                            left: initial;
                        }

                        #crowd-text {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            font-size: 23px;
                            font-weight: bold;
                            background: rgba(0, 0, 0, 0.5);
                            width: 230px;
                            height: 50px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border-radius: 60px;
                        }
                    }

                    @media only screen and (max-device-width: 768px) {
                        .mobile-indicators {
                            display: block;
                            font-size: 36px;
                            text-align: center;
                            width: 100%;
                            margin-top: 36px;

                            p {
                                margin: 5px 0;
                            }
                        }
                    }
                }

                .st-3-timeline {
                    display: flex;
                    width: 625px;
                    justify-content: center;
                    align-items: center;
                    margin: 0 auto;

                    p {
                        font-size: 23px;
                        font-weight: bold;
                        font-stretch: normal;
                        font-style: normal;
                        margin: 0;
                        @media only screen and (max-device-width: 768px) {
                            font-size: 36px;
                        }
                    }
                }
            }

            .st-3-content-2 {
                flex-direction: row !important;
                margin: auto;

                .st-2-left-container {
                    width: auto;
                    margin-right: 70px;

                    img {
                        width: 400px;
                        height: 400px;
                        max-width: 400px;
                        min-width: 400px;
                        max-height: 400px;
                        min-height: 400px;
                    }
                }

                .right-container {
                    h3 {
                        font-size: 36px;
                    }

                    h2 {
                        font-size: 28px;
                        text-align: left;
                    }

                    p {
                        font-size: 14px;
                    }
                }

                @media only screen and (max-device-width: 768px) {
                    flex-direction: column !important;
                    align-items: center;
                    justify-content: space-around !important;

                    .st-2-left-container {
                        margin: 0;

                        img {
                            width: 600px;
                            height: 600px;
                            max-width: 600px;
                            min-width: 600px;
                            max-height: 600px;
                            min-height: 600px;
                        }
                    }


                    .right-container {
                        max-width: 80%;

                        h3 {
                            font-size: 68px;
                        }

                        h2 {
                            font-size: 58px;
                            width: 100%;
                            margin: 0;
                        }

                        p {
                            font-size: 34px;
                        }
                    }
                }
            }

            .st-3-content-3 {
                position: absolute;
                width: 100%;
                top: 0;
                left: 50%;
                transform: translateX(-50%);
            }

            .story-button-container {
                position: absolute;
                right: 95px;
                bottom: 0;
                width: auto;
                cursor: pointer;
                z-index: 20;

                .blue-button {
                    width: auto;
                }
            }
        }
    }
</style>